import type { ListCookingSessionsParams } from '@/types/cooking-session';

export const cookingSessionKeys = {
  all: ['cooking-sessions'] as const,
  lists: () => [...cookingSessionKeys.all, 'list'] as const,
  list: (params?: ListCookingSessionsParams) =>
    [...cookingSessionKeys.lists(), params ?? {}] as const,
  stats: (params?: { locationId?: number }) =>
    [...cookingSessionKeys.all, 'stats', params ?? {}] as const,
  capacity: (params?: { locationId?: number; includeCookingNow?: boolean }) =>
    [...cookingSessionKeys.all, 'capacity', params ?? {}] as const,
};
